import React from "react";
import { Routes, Route } from "react-router-dom";
import ReporteLibroVentasPage from "../pages/ReporteLibroVentasPage";

const ReporteLibroVentasRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<ReporteLibroVentasPage />} />
    </Routes>
  );
};

export default ReporteLibroVentasRoutes;
